import { Component, Input } from '@angular/core';
import { FiltersComponent } from '../../../common/filters.component';

import { DateService } from '../../../common/date.service';

@Component({
	selector: 'app-tourist-guides-reward-filters',
	templateUrl: './tourist-guides-reward-filters.component.html',
	styleUrls: ['./tourist-guides-reward-filters.component.css'],
})
export class TouristGuidesRewardFiltersComponent extends FiltersComponent {
	@Input() touristGuides: Array<any>;
	@Input() calculated: Array<any>;
	filters = {
		search: null,
		date_from: null,
		date_to: null,
		touristGuide: null,
		calculated: null,
	};

	filtersDefault() {
		this.filtersClear();
		const date = new DateService();
		this.filters.date_from = date.daysAdd(-5);
		this.filters.date_to = date.daysAdd(+5);
	}
}
